import { useTranslation } from "react-i18next";
import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { PageSkeleton } from "@/components/PageSkeleton";
import { Shell } from "@/components/Shell";
import { SignIn } from "@/features/session/SignIn";
import { Synchronisaties } from "@/features/synchronisaties/Synchronisaties";
import { useMe } from "@/features/session/useMe";

export function SynchronisatiesPage() {
  const { t } = useTranslation(["paginas", "navigatie", "common"]);
  const { data: me, isPending } = useMe();

  if (isPending) {
    return (
      <Shell>
        <PageSkeleton />
      </Shell>
    );
  }

  if (!me) {
    return (
      <Shell>
        <SignIn />
      </Shell>
    );
  }

  // The API refuses this to anyone else regardless; hiding it here only avoids showing a
  // korpscontact a screen that would answer 403 to everything on it.
  if (!me.isBeheerder) {
    return (
      <Shell name={me.name} letterhead>
        <Card>
          <CardHeader>
            <CardTitle>{t("common:doors.noAccess")}</CardTitle>
            <CardDescription>
              {t("common:doors.noAccessDescription")}
            </CardDescription>
          </CardHeader>
        </Card>
      </Shell>
    );
  }

  return (
    <Shell name={me.name}>
      <header className="mb-6 space-y-1">
        <h1 className="text-2xl font-bold tracking-[-0.02em]">
          {t("navigatie:paginas.synchronisaties.label")}
        </h1>
        <p className="text-sm text-muted-foreground">
          {t("paginas:synchronisaties.uitleg")}
        </p>
      </header>

      <Synchronisaties />
    </Shell>
  );
}
